import React from 'react';
import "../../App.css"

const SignUp = () => {
    return (
        <div>
           <h1 className="sign-up">SIGN UP</h1> 
        </div>
    )
}

export default SignUp
